import { createSlice } from "@reduxjs/toolkit";

export const BedsArraySlice = createSlice({
    name: "bedArraySlice",
    initialState: {
        beds_array: [],
        institutions: []
    },
    reducers: {
        ADD_BEDS_ARRAY: (state, action) => {
            let arr = []
            if (action.payload !== null) {
                state.beds_array = action.payload
                arr.push("全部單位")
                action.payload.forEach(e => {
                    if (e.institution === undefined || e.institution === null || e.institution === "") return
                    if (arr.includes(e.institution)) return
                    arr.push(e.institution)
                });
                state.institutions = arr
            }
        },



    },

})

export const {
    ADD_BEDS_ARRAY
} = BedsArraySlice.actions

export default BedsArraySlice.reducer